module.exports = __webpack_public_path__ + "assets/img/footer3.05a7049d.png";